import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { ModelType } from '/@/modules/core/app/constants/ModelType';
import { Estate } from '@/modules/estate/models/Estate';
import { PetSpecies } from '@/modules/pet/enums/PetSpecies';
import { User } from '@/modules/user/models/User';
import { EstateDistribution } from '@/modules/estatedistribution/models/EstateDistribution';

export class Pet extends BaseEntityModel {
  id?: number;
  estateId?: number;
  name: string;
  species: string;
  specifySpecies?: string;
  estate: Relationship<Estate | null>;
  guardians: Relationship<User[]>;
  alternateGuardians: Relationship<User[]>;
  lumpSum: Relationship<EstateDistribution> | null;

  constructor(model: Partial<Pet> = {}) {
    super(model);

    this.id = model.id;
    this.estateId = model.estateId;
    this.name = model.name;
    this.species = model.species;
    this.specifySpecies = model.specifySpecies;
    this.estate = Estate.mapModelOrNull(model.estate);
    this.guardians = User.mapModels(model.guardians);
    this.alternateGuardians = User.mapModels(model.alternateGuardians);
    this.lumpSum = EstateDistribution.mapModelOrNull(model.lumpSum);
  }

  getModelName(): ModelType {
    return ModelType.PET;
  }

  get isOther(): boolean {
    return this.species === PetSpecies.OTHER.key;
  }

  get firstGuardian(): User | undefined {
    return this.guardians[0];
  }

  get firstAlternateGuardian(): User | undefined {
    return this.alternateGuardians[0];
  }
}
